
import { useState } from 'react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '小規模事業でも依頼できますか？',
      answer: 'はい、もちろんです。従業員数や事業規模に関係なく、業務効率化のニーズがあればお気軽にご相談ください。小規模事業者様向けの料金プランもご用意しております。'
    },
    {
      question: '費用感はどのくらいですか？',
      answer: '案件の規模や複雑さによって異なりますが、小規模な自動化であれば10万円〜、中規模で30万円〜50万円程度が目安です。まずは無料相談で詳細をお聞かせください。'
    },
    {
      question: '維持費はかかりますか？',
      answer: 'Google Apps Scriptを使用した自動化の場合、基本的に維持費はかかりません。ただし、外部サービスとの連携や高度な機能が必要な場合は、月額数千円程度の維持費が発生する場合があります。'
    },
    {
      question: '開発期間はどのくらいですか？',
      answer: '案件の規模によりますが、小規模な自動化であれば1〜2週間、中規模で2〜4週間程度です。お急ぎの場合は優先対応も可能ですので、ご相談ください。'
    },
    {
      question: 'どのような業務が自動化できますか？',
      answer: 'データ入力、レポート作成、メール送信、予約管理、在庫管理、請求書作成など、定型的な業務の多くが自動化可能です。まずは現在の業務内容をお聞かせください。'
    },
    {
      question: '技術的な知識がなくても大丈夫ですか？',
      answer: 'はい、全く問題ありません。技術的な部分は全て弊社で対応いたします。お客様には業務内容をお聞かせいただくだけで、最適な自動化ソリューションをご提案いたします。'
    },
    {
      question: '他社で断られた案件でも対応可能ですか？',
      answer: '技術的に実現可能であれば対応いたします。他社で「難しい」と言われた案件でも、別のアプローチで解決できる場合があります。まずはお気軽にご相談ください。'
    },
    {
      question: 'セキュリティは大丈夫ですか？',
      answer: 'Google Workspaceの高いセキュリティ基準に準拠し、お客様のデータを安全に取り扱います。また、必要に応じて秘密保持契約（NDA）の締結も可能です。'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            よくある<span className="text-blue-600">質問</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            お客様からよくいただくご質問にお答えします
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-gray-50 rounded-lg overflow-hidden">
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-100 transition-colors cursor-pointer"
                >
                  <span className="font-semibold text-gray-900 pr-4">
                    Q. {faq.question}
                  </span>
                  <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-blue-600 text-xl flex-shrink-0`}></i>
                </button>
                
                {openIndex === index && (
                  <div className="px-6 pb-4">
                    <div className="border-t border-gray-200 pt-4">
                      <p className="text-gray-600 leading-relaxed">
                        <span className="font-semibold text-blue-600">A. </span>
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-12 bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl p-8 text-white text-center">
            <h3 className="text-2xl font-bold mb-4">
              他にもご質問がございましたら
            </h3>
            <p className="text-blue-100 mb-6">
              お気軽にお問い合わせください。専門スタッフが丁寧にお答えいたします。
            </p>
            <button 
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              className="bg-white text-blue-600 px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              今すぐ質問する
            </button>
          </div>
        </div>
      </div>

      {/* Schema.org FAQPage構造化データ */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        })}
      </script>
    </section>
  );
};

export default FAQSection;
